/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LayerResultsResponseDto
 */
export interface LayerResultsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof LayerResultsResponseDto
     */
    layerNumber: number;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    rateAdequacy: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    exposureFull: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    pinnacleExposure: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    premium: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    premiumNet: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    lossCost: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    rateOnLine: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    rateOnExposure: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    expectedULR: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    targetedMLR: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    ulrAdequacy: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    returnOnCapital: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    shareOfPremiumNet: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    shareOfExpectedLossCost: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    expectedProfit: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    capitalAllocation: string;
    /**
     * 
     * @type {string}
     * @memberof LayerResultsResponseDto
     */
    lineSize: string;
}

/**
 * Check if a given object implements the LayerResultsResponseDto interface.
 */
export function instanceOfLayerResultsResponseDto(value: object): value is LayerResultsResponseDto {
    if (!('layerNumber' in value) || value['layerNumber'] === undefined) return false;
    if (!('rateAdequacy' in value) || value['rateAdequacy'] === undefined) return false;
    if (!('exposureFull' in value) || value['exposureFull'] === undefined) return false;
    if (!('pinnacleExposure' in value) || value['pinnacleExposure'] === undefined) return false;
    if (!('premium' in value) || value['premium'] === undefined) return false;
    if (!('premiumNet' in value) || value['premiumNet'] === undefined) return false;
    if (!('lossCost' in value) || value['lossCost'] === undefined) return false;
    if (!('rateOnLine' in value) || value['rateOnLine'] === undefined) return false;
    if (!('rateOnExposure' in value) || value['rateOnExposure'] === undefined) return false;
    if (!('expectedULR' in value) || value['expectedULR'] === undefined) return false;
    if (!('targetedMLR' in value) || value['targetedMLR'] === undefined) return false;
    if (!('ulrAdequacy' in value) || value['ulrAdequacy'] === undefined) return false;
    if (!('returnOnCapital' in value) || value['returnOnCapital'] === undefined) return false;
    if (!('shareOfPremiumNet' in value) || value['shareOfPremiumNet'] === undefined) return false;
    if (!('shareOfExpectedLossCost' in value) || value['shareOfExpectedLossCost'] === undefined) return false;
    if (!('expectedProfit' in value) || value['expectedProfit'] === undefined) return false;
    if (!('capitalAllocation' in value) || value['capitalAllocation'] === undefined) return false;
    if (!('lineSize' in value) || value['lineSize'] === undefined) return false;
    return true;
}

export function LayerResultsResponseDtoFromJSON(json: any): LayerResultsResponseDto {
    return LayerResultsResponseDtoFromJSONTyped(json, false);
}

export function LayerResultsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayerResultsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'layerNumber': json['layerNumber'],
        'rateAdequacy': json['rateAdequacy'],
        'exposureFull': json['exposureFull'],
        'pinnacleExposure': json['pinnacleExposure'],
        'premium': json['premium'],
        'premiumNet': json['premiumNet'],
        'lossCost': json['lossCost'],
        'rateOnLine': json['rateOnLine'],
        'rateOnExposure': json['rateOnExposure'],
        'expectedULR': json['expectedULR'],
        'targetedMLR': json['targetedMLR'],
        'ulrAdequacy': json['ulrAdequacy'],
        'returnOnCapital': json['returnOnCapital'],
        'shareOfPremiumNet': json['shareOfPremiumNet'],
        'shareOfExpectedLossCost': json['shareOfExpectedLossCost'],
        'expectedProfit': json['expectedProfit'],
        'capitalAllocation': json['capitalAllocation'],
        'lineSize': json['lineSize'],
    };
}

export function LayerResultsResponseDtoToJSON(json: any): LayerResultsResponseDto {
    return LayerResultsResponseDtoToJSONTyped(json, false);
}

export function LayerResultsResponseDtoToJSONTyped(value?: LayerResultsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'layerNumber': value['layerNumber'],
        'rateAdequacy': value['rateAdequacy'],
        'exposureFull': value['exposureFull'],
        'pinnacleExposure': value['pinnacleExposure'],
        'premium': value['premium'],
        'premiumNet': value['premiumNet'],
        'lossCost': value['lossCost'],
        'rateOnLine': value['rateOnLine'],
        'rateOnExposure': value['rateOnExposure'],
        'expectedULR': value['expectedULR'],
        'targetedMLR': value['targetedMLR'],
        'ulrAdequacy': value['ulrAdequacy'],
        'returnOnCapital': value['returnOnCapital'],
        'shareOfPremiumNet': value['shareOfPremiumNet'],
        'shareOfExpectedLossCost': value['shareOfExpectedLossCost'],
        'expectedProfit': value['expectedProfit'],
        'capitalAllocation': value['capitalAllocation'],
        'lineSize': value['lineSize'],
    };
}

